import { Injectable } from '@angular/core';
import {BaseServiceService} from '../base-service.service';
import {Observable} from 'rxjs';
import {Invoice} from '../models/Invoice';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends BaseServiceService{

  public getInvoice(id: number): Observable<Invoice> {
    return this.get('client_area/invoice/' + id);
  }

  public getBankInvoice(id: number, modo: number = 2): Observable<Blob> {
    return this.http.get(
      this.getUrl(`client_area/render_invoice/${id}?output=${modo}`),
      {headers: this.getHeaders(), responseType: 'blob'},
    );
  }

  public payInvoiceWithCreditCard(id: string, obj: object): Observable<any> {
    return this.http.post(this.getUrl("client_area/proccess_payment_credit_card/" + id), obj, {headers: this.getHeaders()});
  }
}
